import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class WebhookLogs extends Form {

    getLogs(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account-webhook-log?page=' + self.page + '&type=' + self.type;

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {

                    console.error(error);

                    self.setError(error);

                    reject(error);
                })
        });
    }

    selectLog(index) {
        let self = this;

        return new Promise(resolve => {

            self.selected = this.index_data.data[index];

            resolve(self.selected);
        });
    }
}
